<template>
    <view-card headline="시공지" :disabled="!isAdmin">
        <v-row align="baseline">
            <v-col class="py-0">
                <v-text-field v-model="inquiry.postcode" type="text" readonly label="우편번호" placeholder=" " @click="search" />
            </v-col>
            <v-col class="py-0" cols="auto">
                <v-btn small @click="search">검색</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="py-0">
                <v-text-field v-model="inquiry.address1" type="text" readonly label="주소" placeholder=" " @click="search" />
            </v-col>
        </v-row>
        <v-row>
            <v-col class="py-0">
                <v-text-field v-model="inquiry.address2" type="text" label="상세주소" placeholder=" " hide-details />
            </v-col>
        </v-row>
        <v-card-actions slot="actions" class="pt-0 px-4 pb-4">
            <v-row justify="end">
                <v-col cols="auto" class="py-0">
                    <v-btn small color="primary" @click="save">저장</v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
        <daum-postcode ref="daum-postcode" @change="set"></daum-postcode>
    </view-card>
</template>
<script>
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import viewCard from "../dumb/view-card.vue";
export default {
    components: { viewCard, DaumPostcode },
    props: {
        value: { type: Object, default: null },
        isAdmin: { type: Boolean, default: false },
    },
    data() {
        return {
            inquiry: {},
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            const { postcode, address1, address2 } = this.value;

            this.inquiry = JSON.parse(JSON.stringify({ postcode, address1, address2 }));
        },
        search() {
            this.$refs["daum-postcode"].open();
        },
        set(data) {
            this.inquiry.postcode = data.postcode;
            this.inquiry.address1 = data.address;
        },
        save() {
            this.$emit("clickSave", this.inquiry);
        },
    },
    watch: {
        value() {
            this.init();
        },
    },
};
</script>
